import React from 'react'
import PropTypes from 'prop-types'
import StoredDataItem from './StoredDataItem'
import Link from 'components/common/Link'

export default class StoredData extends React.PureComponent {
  static propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    age: PropTypes.number,
    gender: PropTypes.string,
    lat: PropTypes.string,
    long: PropTypes.string,
    locale: PropTypes.string,
    timezone: PropTypes.number
  }

  render() {
    const latlong = this.props.lat
      ? `${this.props.lat}/${this.props.long}`
      : null

    return (
      <React.Fragment>
        <StoredDataItem title="Name">
          {this.props.firstName} {this.props.lastName}
        </StoredDataItem>
        <StoredDataItem title="Age">{this.props.age}</StoredDataItem>
        <StoredDataItem title="Gender">{this.props.gender}</StoredDataItem>
        <StoredDataItem title="Location">{latlong}</StoredDataItem>
        <StoredDataItem title="Language">{this.props.locale}</StoredDataItem>
        <StoredDataItem title="Timezone">{this.props.timezone}</StoredDataItem>
        <StoredDataItem title="Photos">
          <Link to="/profile">Your Profile</Link>
        </StoredDataItem>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/StoredData.js